import CobbledRoadTileEntity from "@/game/entities/roads/CobbledRoadTileEntity.ts";
import CobbledRoadTileEntity10 from "@/game/entities/roads/CobbledRoadTileEntity10.ts";
import CobbledRoadTileEntity11 from "@/game/entities/roads/CobbledRoadTileEntity11.ts";
import CobbledRoadTileEntity2 from "@/game/entities/roads/CobbledRoadTileEntity2.ts";
import CobbledRoadTileEntity3 from "@/game/entities/roads/CobbledRoadTileEntity3.ts";
import CobbledRoadTileEntity4 from "@/game/entities/roads/CobbledRoadTileEntity4.ts";
import CobbledRoadTileEntity5 from "@/game/entities/roads/CobbledRoadTileEntity5.ts";
import CobbledRoadTileEntity6 from "@/game/entities/roads/CobbledRoadTileEntity6.ts";
import CobbledRoadTileEntity7 from "@/game/entities/roads/CobbledRoadTileEntity7.ts";
import CobbledRoadTileEntity8 from "@/game/entities/roads/CobbledRoadTileEntity8.ts";
import CobbledRoadTileEntity9 from "@/game/entities/roads/CobbledRoadTileEntity9.ts";
import DirtRoadTileEntity from "@/game/entities/roads/DirtRoadTileEntity.ts";
import DirtRoadTileEntity10 from "@/game/entities/roads/DirtRoadTileEntity10.ts";
import DirtRoadTileEntity11 from "@/game/entities/roads/DirtRoadTileEntity11.ts";
import DirtRoadTileEntity2 from "@/game/entities/roads/DirtRoadTileEntity2.ts";
import DirtRoadTileEntity3 from "@/game/entities/roads/DirtRoadTileEntity3.ts";
import DirtRoadTileEntity4 from "@/game/entities/roads/DirtRoadTileEntity4.ts";
import DirtRoadTileEntity5 from "@/game/entities/roads/DirtRoadTileEntity5.ts";
import DirtRoadTileEntity6 from "@/game/entities/roads/DirtRoadTileEntity6.ts";
import DirtRoadTileEntity7 from "@/game/entities/roads/DirtRoadTileEntity7.ts";
import DirtRoadTileEntity8 from "@/game/entities/roads/DirtRoadTileEntity8.ts";
import DirtRoadTileEntity9 from "@/game/entities/roads/DirtRoadTileEntity9.ts";
import DirtRoadTutorialTileEntity from "@/game/entities/roads/DirtRoadTutorialTileEntity.ts";
import GravelRoadTileEntity from "@/game/entities/roads/GravelRoadTileEntity.ts";
import GravelRoadTileEntity10 from "@/game/entities/roads/GravelRoadTileEntity10.ts";
import GravelRoadTileEntity11 from "@/game/entities/roads/GravelRoadTileEntity11.ts";
import GravelRoadTileEntity2 from "@/game/entities/roads/GravelRoadTileEntity2.ts";
import GravelRoadTileEntity3 from "@/game/entities/roads/GravelRoadTileEntity3.ts";
import GravelRoadTileEntity4 from "@/game/entities/roads/GravelRoadTileEntity4.ts";
import GravelRoadTileEntity5 from "@/game/entities/roads/GravelRoadTileEntity5.ts";
import GravelRoadTileEntity6 from "@/game/entities/roads/GravelRoadTileEntity6.ts";
import GravelRoadTileEntity7 from "@/game/entities/roads/GravelRoadTileEntity7.ts";
import GravelRoadTileEntity8 from "@/game/entities/roads/GravelRoadTileEntity8.ts";
import GravelRoadTileEntity9 from "@/game/entities/roads/GravelRoadTileEntity9.ts";
import StoneBridgeTileEntity from "@/game/entities/roads/StoneBridgeTileEntity.ts";
import StoneBridgeTileEntity2 from "@/game/entities/roads/StoneBridgeTileEntity2.ts";
import WoodenBridgeTileEntity from "@/game/entities/roads/WoodenBridgeTileEntity.ts";
import WoodenBridgeTileEntity1 from "@/game/entities/roads/WoodenBridgeTileEntity1.ts";
import WoodenBridgeTileEntity2 from "@/game/entities/roads/WoodenBridgeTileEntity2.ts";
import { type TileCoordinates } from "@/types/tile";
import { type FrameName } from "../entities/config";
import CobbledRoadTileEntity1 from "../entities/roads/CobbledRoadTileEntity1.ts";
import DirtRoadTileEntity1 from "../entities/roads/DirtRoadTileEntity1.ts";
import FordCrossingTileEntity from "../entities/roads/FordCrossingTileEntity.ts";
import FordCrossingTileEntity1 from "../entities/roads/FordCrossingTileEntity1.ts";
import FordCrossingTileEntity2 from "../entities/roads/FordCrossingTileEntity2.ts";
import GravelRoadTileEntity1 from "../entities/roads/GravelRoadTileEntity1";
import HillyRoadTileEntity from "../entities/roads/HillyRoadTileEntity.ts";
import MountainRoadTileEntity from "../entities/roads/MountainRoadTileEntity.ts";
import StoneBridgeTileEntity1 from "../entities/roads/StoneBridgeTileEntity1.ts";
import type TileEntity from "../entities/TileEntity";
import type TileRepository from "../TileRepository";

const map = new Map<FrameName, typeof TileEntity>();
map.set(DirtRoadTutorialTileEntity.frameName, DirtRoadTutorialTileEntity);
map.set(DirtRoadTileEntity.frameName, DirtRoadTileEntity);
map.set(DirtRoadTileEntity1.frameName, DirtRoadTileEntity1);
map.set(DirtRoadTileEntity2.frameName, DirtRoadTileEntity2);
map.set(DirtRoadTileEntity3.frameName, DirtRoadTileEntity3);
map.set(DirtRoadTileEntity4.frameName, DirtRoadTileEntity4);
map.set(DirtRoadTileEntity5.frameName, DirtRoadTileEntity5);
map.set(DirtRoadTileEntity6.frameName, DirtRoadTileEntity6);
map.set(DirtRoadTileEntity7.frameName, DirtRoadTileEntity7);
map.set(DirtRoadTileEntity8.frameName, DirtRoadTileEntity8);
map.set(DirtRoadTileEntity9.frameName, DirtRoadTileEntity9);
map.set(DirtRoadTileEntity10.frameName, DirtRoadTileEntity10);
map.set(DirtRoadTileEntity11.frameName, DirtRoadTileEntity11);
map.set(GravelRoadTileEntity.frameName, GravelRoadTileEntity);
map.set(GravelRoadTileEntity1.frameName, GravelRoadTileEntity1);
map.set(GravelRoadTileEntity2.frameName, GravelRoadTileEntity2);
map.set(GravelRoadTileEntity3.frameName, GravelRoadTileEntity3);
map.set(GravelRoadTileEntity4.frameName, GravelRoadTileEntity4);
map.set(GravelRoadTileEntity5.frameName, GravelRoadTileEntity5);
map.set(GravelRoadTileEntity6.frameName, GravelRoadTileEntity6);
map.set(GravelRoadTileEntity7.frameName, GravelRoadTileEntity7);
map.set(GravelRoadTileEntity8.frameName, GravelRoadTileEntity8);
map.set(GravelRoadTileEntity9.frameName, GravelRoadTileEntity9);
map.set(GravelRoadTileEntity10.frameName, GravelRoadTileEntity10);
map.set(GravelRoadTileEntity11.frameName, GravelRoadTileEntity11);
map.set(CobbledRoadTileEntity.frameName, CobbledRoadTileEntity);
map.set(CobbledRoadTileEntity1.frameName, CobbledRoadTileEntity1);
map.set(CobbledRoadTileEntity2.frameName, CobbledRoadTileEntity2);
map.set(CobbledRoadTileEntity3.frameName, CobbledRoadTileEntity3);
map.set(CobbledRoadTileEntity4.frameName, CobbledRoadTileEntity4);
map.set(CobbledRoadTileEntity5.frameName, CobbledRoadTileEntity5);
map.set(CobbledRoadTileEntity6.frameName, CobbledRoadTileEntity6);
map.set(CobbledRoadTileEntity7.frameName, CobbledRoadTileEntity7);
map.set(CobbledRoadTileEntity8.frameName, CobbledRoadTileEntity8);
map.set(CobbledRoadTileEntity9.frameName, CobbledRoadTileEntity9);
map.set(CobbledRoadTileEntity10.frameName, CobbledRoadTileEntity10);
map.set(CobbledRoadTileEntity11.frameName, CobbledRoadTileEntity11);
map.set(FordCrossingTileEntity.frameName, FordCrossingTileEntity);
map.set(FordCrossingTileEntity1.frameName, FordCrossingTileEntity1);
map.set(FordCrossingTileEntity2.frameName, FordCrossingTileEntity2);
map.set(WoodenBridgeTileEntity.frameName, WoodenBridgeTileEntity);
map.set(WoodenBridgeTileEntity1.frameName, WoodenBridgeTileEntity1);
map.set(WoodenBridgeTileEntity2.frameName, WoodenBridgeTileEntity2);
map.set(StoneBridgeTileEntity.frameName, StoneBridgeTileEntity);
map.set(StoneBridgeTileEntity1.frameName, StoneBridgeTileEntity1);
map.set(StoneBridgeTileEntity2.frameName, StoneBridgeTileEntity2);
map.set(MountainRoadTileEntity.frameName, MountainRoadTileEntity);
map.set(HillyRoadTileEntity.frameName, HillyRoadTileEntity);

// TODO: rename + rename file
export const getRoadTileEntity = (type: FrameName): typeof TileEntity | null =>
	map.has(type) ? map.get(type)! : null;

// TODO: rename + rename file
export const createRoadTileEntity = (
	type: FrameName,
	coordinates: TileCoordinates,
	tilerepo: TileRepository,
): TileEntity | null => {
	const entity = getRoadTileEntity(type);
	return entity ? new entity(coordinates, tilerepo) : null;
};
